"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createStore = createStore;
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _state = require("../reducers/state");
var _view = require("../reducers/view");
var _tabs = require("../reducers/tabs");
var _flow = require("../reducers/flow");
var _login = require("../reducers/login");
var _authentication = require("../reducers/authentication");
var _registration = require("../reducers/registration");
var _social = require("../reducers/social");
var _phoneAuth = require("../reducers/phoneAuth");
var _agreement = require("../reducers/agreement");
var _autoFocusDisabled = require("../reducers/autoFocusDisabled");
var _source = require("../reducers/source");
function createStore(options) {
  const reducer = reduceReducers(_state.stateReducer, (0, _redux.combineReducers)({
    view: _view.changeViewReducer,
    activeTab: _tabs.changeTabReducer,
    activeFlow: _flow.changeFlowReducer,
    login: _login.changeLoginReducer,
    phoneAuth: reduceReducers(_phoneAuth.sendValidationCodeReducer, _phoneAuth.registerOrAuthorizeReducer, _phoneAuth.changePhoneReducer, _phoneAuth.checkPhoneReducer, _phoneAuth.authenticateByTokenReducer, _phoneAuth.registerOrAuthorizeByTokenReducer, _phoneAuth.autosubmitEnabledReducer),
    authentication: reduceReducers(_authentication.checkEmailReducer, _authentication.changePasswordReducer, _authentication.authenticateReducer, _authentication.twoFactorReducer, _authentication.restoreReducer, _authentication.resetReducer),
    registration: reduceReducers(_registration.registerReducer, _registration.sendSmsReducer, _registration.confirmPhoneReducer, _registration.professionalUserReducer),
    social: reduceReducers(_social.authenticateReducer, _social.phoneReducer, _social.emailReducer, _social.createReducer, _social.mergeReducer, _social.expandReducer),
    agreement: _agreement.agreementReducer,
    autoFocusDisabled: _autoFocusDisabled.autoFocusDisabledReducer,
    // добавлен в рамках эксперимента AUD-1403, по завершению будет удален
    isRememberAccountsFlow: state => state || false,
    source: _source.sourceReducer,
    subdomain: state => state || 'www'
  }));
  const composeEnhancers = typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;
  const {
    context
  } = options;
  const enhancers = composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk.default.withExtraArgument(context)));
  if (options.preloadedState) {
    return (0, _redux.createStore)(reducer, options.preloadedState, enhancers);
  } else {
    return (0, _redux.createStore)(reducer, enhancers);
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function reduceReducers() {
  for (var _len = arguments.length, reducers = new Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }
  return (prevState, action) => reducers.reduce((newState, reducer) => reducer(newState, action), prevState);
}